module.exports = __webpack_public_path__ + "media/assets/images/flags/cv-1b6f5d348e8ad57cabd695bb92cc55a3.svg";